import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { isSupabaseReady } from '@/lib/supabase';
import { routes } from '@/config/routes';

/**
 * Requires a signed-in session when the product data backend is configured
 * (same policy as HOTTR.tv). Passport login still works anytime via /auth;
 * without a data project, local-only mode remains usable after the PIN gate.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading, backendReady } = useAuth();
  const location = useLocation();

  if (!isSupabaseReady() || !backendReady) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-hottr-ink text-white/55">
        <p className="font-display text-[11px] uppercase tracking-hottr-label">Loading…</p>
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${routes.auth}?next=${next}`} replace />;
  }

  return <>{children}</>;
}
